// Generated by purs version 0.15.15
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_HttpStatusCode from "../Ouroboros.Models.Brands.HttpStatusCode/index.js";
import * as Ouroboros_Models_Clients_ClientProject from "../Ouroboros.Models.Clients.ClientProject/index.js";
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Programs_Controllers_JwtSession from "../Ouroboros.Programs.Controllers.JwtSession/index.js";
import * as Ouroboros_Services_FFI_Effect from "../Ouroboros.Services.FFI.Effect/index.js";
import * as Ouroboros_Services_FFI_Env from "../Ouroboros.Services.FFI.Env/index.js";
import * as Ouroboros_Services_FFI_Http from "../Ouroboros.Services.FFI.Http/index.js";
import * as Ouroboros_Services_FFI_Uuid from "../Ouroboros.Services.FFI.Uuid/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var validationError = function (message) {
    return {
        type: "ValidationError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
        statusCode: Data_Maybe.Nothing.value
    };
};
var unauthorizedError = /* #__PURE__ */ (function () {
    return {
        type: "Unauthorized",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Unauthorized"),
        statusCode: Data_Maybe.Nothing.value
    };
})();
var traceHeaders = function (headers) {
    return Ouroboros_Services_FFI_Http.mkHeaders(append(headers)([ new Data_Tuple.Tuple("X-Trace-ID", Ouroboros_Services_FFI_Uuid.uuidV7(Data_Unit.unit)) ]));
};
var serverError = function (status) {
    return {
        type: "ServerError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Server responded with an error: " + show(status)),
        statusCode: new Data_Maybe.Just(Ouroboros_Models_Brands_HttpStatusCode.makeHttpStatusCode(Data_Int.toNumber(status)))
    };
};
var parseJson = function (response) {
    return Ouroboros_Services_FFI_Effect.tryPromise(function (v) {
        return Ouroboros_Services_FFI_Http.responseJson(response);
    })(function (v) {
        return {
            type: "ValidationError",
            message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Response validation failed"),
            statusCode: Data_Maybe.Nothing.value
        };
    });
};
var networkError = /* #__PURE__ */ (function () {
    return {
        type: "NetworkError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Failed to connect to the server. Please check your internet connection."),
        statusCode: Data_Maybe.Nothing.value
    };
})();
var handleUnauthorized = function (onUnauthorized) {
    return Ouroboros_Services_FFI_Effect.fromIO(Ouroboros_Programs_Controllers_JwtSession.actionEffect(onUnauthorized));
};
var fetchWithTrace = function (url) {
    return function (init) {
        return Ouroboros_Services_FFI_Effect.tryPromise(function (v) {
            return Ouroboros_Services_FFI_Http.fetch_(url)(init);
        })(function (v) {
            return networkError;
        });
    };
};
var ensureOk = function (onUnauthorized) {
    return function (response) {
        var $16 = Ouroboros_Services_FFI_Http.responseStatus(response) === 401;
        if ($16) {
            return Ouroboros_Services_FFI_Effect.flatMap(handleUnauthorized(onUnauthorized))(function (v) {
                return Ouroboros_Services_FFI_Effect.fail(unauthorizedError);
            });
        };
        var $17 = !Ouroboros_Services_FFI_Http.responseOk(response);
        if ($17) {
            return Ouroboros_Services_FFI_Effect.fail(serverError(Ouroboros_Services_FFI_Http.responseStatus(response)));
        };
        return Ouroboros_Services_FFI_Effect.succeed(response);
    };
};
var decodeResponse = function (onUnauthorized) {
    return function (response) {
        return function (decoder) {
            return function (message) {
                return Ouroboros_Services_FFI_Effect.flatMap(ensureOk(onUnauthorized)(response))(function (okResponse) {
                    return Ouroboros_Services_FFI_Effect.flatMap(parseJson(okResponse))(function (payload) {
                        var v = decoder(payload);
                        if (v instanceof Data_Either.Left) {
                            return Ouroboros_Services_FFI_Effect.fail(validationError(message));
                        };
                        if (v instanceof Data_Either.Right) {
                            return Ouroboros_Services_FFI_Effect.succeed(v.value0);
                        };
                        throw new Error("Failed pattern match at Ouroboros.Services.Ouroboros.ClientProject (line 90, column 7 - line 92, column 45): " + [ v.constructor.name ]);
                    });
                });
            };
        };
    };
};
var createDefaultClientProjectClient = function (onUnauthorized) {
    return {
        listClients: Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/clients/clients")(Ouroboros_Services_FFI_Http.requestInitNoBody("GET")(traceHeaders([  ]))))(function (response) {
            var $21 = Ouroboros_Services_FFI_Http.responseStatus(response) === 204;
            if ($21) {
                return Ouroboros_Services_FFI_Effect.succeed({
                    items: [  ]
                });
            };
            return decodeResponse(onUnauthorized)(response)(Ouroboros_Models_Clients_ClientProject.decodeClientListResponse)("Invalid client list payload");
        }),
        createClient: function (request) {
            return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/clients/clients")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                return Ouroboros_Services_FFI_Effect.map(function (v) {
                    return Ouroboros_Models_Core_Ok.ok;
                })(ensureOk(onUnauthorized)(response));
            });
        },
        listProjects: function (clientId) {
            return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + ("/v1/clients/clients/" + (clientId + "/projects")))(Ouroboros_Services_FFI_Http.requestInitNoBody("GET")(traceHeaders([  ]))))(function (response) {
                return decodeResponse(onUnauthorized)(response)(Ouroboros_Models_Clients_ClientProject.decodeProjectListResponse)("Invalid project list payload");
            });
        },
        createProject: function (clientId) {
            return function (request) {
                return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + ("/v1/clients/clients/" + (clientId + "/projects")))(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                    return Ouroboros_Services_FFI_Effect.map(function (v) {
                        return Ouroboros_Models_Core_Ok.ok;
                    })(ensureOk(onUnauthorized)(response));
                });
            };
        },
        updateProject: function (projectId) {
            return function (request) {
                return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + ("/v1/clients/projects/" + projectId))(Ouroboros_Services_FFI_Http.requestInitJson("PUT")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                    return Ouroboros_Services_FFI_Effect.map(function (v) {
                        return Ouroboros_Models_Core_Ok.ok;
                    })(ensureOk(onUnauthorized)(response));
                });
            };
        },
        deleteProject: function (projectId) {
            return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + ("/v1/clients/projects/" + projectId))(Ouroboros_Services_FFI_Http.requestInitNoBody("DELETE")(traceHeaders([  ]))))(function (response) {
                return Ouroboros_Services_FFI_Effect.map(function (v) {
                    return Ouroboros_Models_Core_Ok.ok;
                })(ensureOk(onUnauthorized)(response));
            });
        },
        listProjectDocuments: function (projectId) {
            return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + ("/v1/clients/projects/" + (projectId + "/documents")))(Ouroboros_Services_FFI_Http.requestInitNoBody("GET")(traceHeaders([  ]))))(function (response) {
                return decodeResponse(onUnauthorized)(response)(Ouroboros_Models_Clients_ClientProject.decodeProjectDocumentListResponse)("Invalid project document list payload");
            });
        },
        presignProjectDocuments: function (_clientId) {
            return function (projectId) {
                return function (request) {
                    return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + ("/v1/clients/projects/" + (projectId + "/documents/presign")))(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                        return decodeResponse(onUnauthorized)(response)(Ouroboros_Models_Clients_ClientProject.decodeProjectDocumentPresignResponse)("Invalid project document presign payload");
                    });
                };
            };
        },
        deleteProjectDocument: function (projectId) {
            return function (documentId) {
                return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + ("/v1/clients/projects/" + (projectId + ("/documents/" + documentId))))(Ouroboros_Services_FFI_Http.requestInitNoBody("DELETE")(traceHeaders([  ]))))(function (response) {
                    return Ouroboros_Services_FFI_Effect.map(function (v) {
                        return Ouroboros_Models_Core_Ok.ok;
                    })(ensureOk(onUnauthorized)(response));
                });
            };
        }
    };
};
export {
    createDefaultClientProjectClient
};
//# sourceMappingURL=index.js.map
